import React from 'react';
import styled from 'styled-components';
import { COLOR_DARK_GREEN } from '../../../common/variables';
import { GatsbyImage } from 'gatsby-plugin-image';
import { ContentWrapper, ImageContainer, TextContainer } from './style';

const Container = styled.div`
  h2 {
    margin-bottom: 35px;
    color: ${COLOR_DARK_GREEN};
    font-weight: 400;
    font-size: 2rem;
  }
`;

const SingleStream = (props) => {
  const { image, desc, imagealt, streamName } = props;
  return (
    <Container>
      <h2>
        This <i>Recycling Stream</i> is right for you
      </h2>
      <ContentWrapper>
        <ImageContainer>
          <GatsbyImage image={image.gatsbyImageData} alt={imagealt} />
        </ImageContainer>
        <TextContainer>
          <h3>{streamName}</h3>
          <div
            className="stream-description"
            dangerouslySetInnerHTML={{ __html: desc }}
          />
        </TextContainer>
      </ContentWrapper>
    </Container>
  );
};

export default SingleStream;
